import { render, staticRenderFns } from "./multireceipt.vue?vue&type=template&id=3886b013&"
import script from "./multireceipt.vue?vue&type=script&lang=js&"
export * from "./multireceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports